import { apiConfig } from "config/app-config";
import networkService from "services/networkService";
import type { CreateMetierModel, Metier, PatchData } from "models";
import { apiFetch } from "./apiHelperService";
import { Endpoints } from "enums";

const apiUrl = `${apiConfig.apimBaseUrl}/${apiConfig.productsApi.apiName}/${Endpoints.METIERS}`;
const scope = apiConfig.productsApi.scopes;

async function createHeaders(): Promise<HeadersInit> {
  return networkService.createHeaders(scope);
}

/**
 * Récupère un métier en fonction de son identifiant unique
 * @param metierId l'identifiant unique
 * @returns un métier
 */
async function getById(metierId: string): Promise<Metier> {
  const url = `${apiUrl}/${metierId}`;
  const options: RequestInit = {
    method: "GET",
    headers: await createHeaders(),
    mode: "cors",
  };
  return apiFetch<Metier>(url, options);
}

/**
 * Récupère tous les métiers
 * @returns Liste des métiers
 */
async function getAll(): Promise<Array<Metier>> {
  const url = apiUrl;
  const options: RequestInit = {
    method: "GET",
    headers: await createHeaders(),
    mode: "cors",
  };
  return apiFetch<Array<Metier>>(url, options);
}

/**
 * Créée un nouvel métier
 * @returns Le métier créé
 */
async function create(metierToCreate: CreateMetierModel): Promise<Metier> {
  const url = apiUrl;

  const options: RequestInit = {
    method: "POST",
    headers: await createHeaders(),
    mode: "cors",
    body: JSON.stringify(metierToCreate),
  };
  return apiFetch<Metier>(url, options);
}

/**
 * Patche un métier
 * @param metierId l'id du métier
 * @param patchData un tableau de PatchTRUC contenant les modifications à apporter au métier
 * @returns le métier modifié
 */
async function patch(metierId: string, patchData: Array<PatchData>): Promise<Metier> {
  const url = `${apiUrl}/${metierId}`;
  const options: RequestInit = {
    method: "PATCH",
    headers: await createHeaders(),
    body: JSON.stringify(patchData),
  };
  return apiFetch<Metier>(url, options);
}

/**
 * Supprime un métier
 * @param metierId l'id du métier
 */
async function deleteById(metierId: string): Promise<void> {
  const url = `${apiUrl}/${metierId}`;
  const options: RequestInit = {
    method: "DELETE",
    headers: await createHeaders(),
  };
  await fetch(url, options);
}

const metiersService = {
  getAll,
  getById,
  create,
  patch,
  deleteById,
};
export default metiersService;
